export function degreeToRadian(degree) {
    return degree * 0.017453;
}
export function radianToDegree(radian) {
    return radian * 57.29578;
}
export function metersToInches(meters) {
    return meters * 39.3701;
}
export function inchesToMeters(inches) {
    return inches / 39.3701;
}
